package com.tedd.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Long
import kotlin.String

public class LoanQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun <T : Any> selectAll(mapper: (
    id: String,
    direction: String,
    counterparty: String,
    principal: Long,
    interest: Long,
    currency: String,
    date: String,
    due_date: String?,
    note: String?,
    account_id: String?,
    tx_id: String?,
    status: String,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(-738_983_429, arrayOf("loan"), driver, "Loan.sq", "selectAll",
      "SELECT loan.id, loan.direction, loan.counterparty, loan.principal, loan.interest, loan.currency, loan.date, loan.due_date, loan.note, loan.account_id, loan.tx_id, loan.status, loan.order_index, loan.created_at, loan.updated_at, loan.is_deleted, loan.deleted_at, loan.synced_at FROM loan WHERE is_deleted = 0 ORDER BY status, date DESC, created_at DESC") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getLong(3)!!,
      cursor.getLong(4)!!,
      cursor.getString(5)!!,
      cursor.getString(6)!!,
      cursor.getString(7),
      cursor.getString(8),
      cursor.getString(9),
      cursor.getString(10),
      cursor.getString(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13)!!,
      cursor.getLong(14)!!,
      cursor.getLong(15)!!,
      cursor.getLong(16),
      cursor.getLong(17)
    )
  }

  public fun selectAll(): Query<Loan> = selectAll { id, direction, counterparty, principal,
      interest, currency, date, due_date, note, account_id, tx_id, status, order_index, created_at,
      updated_at, is_deleted, deleted_at, synced_at ->
    Loan(
      id,
      direction,
      counterparty,
      principal,
      interest,
      currency,
      date,
      due_date,
      note,
      account_id,
      tx_id,
      status,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectById(id: String, mapper: (
    id: String,
    direction: String,
    counterparty: String,
    principal: Long,
    interest: Long,
    currency: String,
    date: String,
    due_date: String?,
    note: String?,
    account_id: String?,
    tx_id: String?,
    status: String,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getLong(3)!!,
      cursor.getLong(4)!!,
      cursor.getString(5)!!,
      cursor.getString(6)!!,
      cursor.getString(7),
      cursor.getString(8),
      cursor.getString(9),
      cursor.getString(10),
      cursor.getString(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13)!!,
      cursor.getLong(14)!!,
      cursor.getLong(15)!!,
      cursor.getLong(16),
      cursor.getLong(17)
    )
  }

  public fun selectById(id: String): Query<Loan> = selectById(id) { id_, direction, counterparty,
      principal, interest, currency, date, due_date, note, account_id, tx_id, status, order_index,
      created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Loan(
      id_,
      direction,
      counterparty,
      principal,
      interest,
      currency,
      date,
      due_date,
      note,
      account_id,
      tx_id,
      status,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectDirty(mapper: (
    id: String,
    direction: String,
    counterparty: String,
    principal: Long,
    interest: Long,
    currency: String,
    date: String,
    due_date: String?,
    note: String?,
    account_id: String?,
    tx_id: String?,
    status: String,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(-1_490_780_756, arrayOf("loan"), driver, "Loan.sq", "selectDirty",
      "SELECT loan.id, loan.direction, loan.counterparty, loan.principal, loan.interest, loan.currency, loan.date, loan.due_date, loan.note, loan.account_id, loan.tx_id, loan.status, loan.order_index, loan.created_at, loan.updated_at, loan.is_deleted, loan.deleted_at, loan.synced_at FROM loan WHERE synced_at IS NULL OR synced_at < updated_at") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getLong(3)!!,
      cursor.getLong(4)!!,
      cursor.getString(5)!!,
      cursor.getString(6)!!,
      cursor.getString(7),
      cursor.getString(8),
      cursor.getString(9),
      cursor.getString(10),
      cursor.getString(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13)!!,
      cursor.getLong(14)!!,
      cursor.getLong(15)!!,
      cursor.getLong(16),
      cursor.getLong(17)
    )
  }

  public fun selectDirty(): Query<Loan> = selectDirty { id, direction, counterparty, principal,
      interest, currency, date, due_date, note, account_id, tx_id, status, order_index, created_at,
      updated_at, is_deleted, deleted_at, synced_at ->
    Loan(
      id,
      direction,
      counterparty,
      principal,
      interest,
      currency,
      date,
      due_date,
      note,
      account_id,
      tx_id,
      status,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByIdAnyState(id: String, mapper: (
    id: String,
    direction: String,
    counterparty: String,
    principal: Long,
    interest: Long,
    currency: String,
    date: String,
    due_date: String?,
    note: String?,
    account_id: String?,
    tx_id: String?,
    status: String,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdAnyStateQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getLong(3)!!,
      cursor.getLong(4)!!,
      cursor.getString(5)!!,
      cursor.getString(6)!!,
      cursor.getString(7),
      cursor.getString(8),
      cursor.getString(9),
      cursor.getString(10),
      cursor.getString(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13)!!,
      cursor.getLong(14)!!,
      cursor.getLong(15)!!,
      cursor.getLong(16),
      cursor.getLong(17)
    )
  }

  public fun selectByIdAnyState(id: String): Query<Loan> = selectByIdAnyState(id) { id_, direction,
      counterparty, principal, interest, currency, date, due_date, note, account_id, tx_id, status,
      order_index, created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Loan(
      id_,
      direction,
      counterparty,
      principal,
      interest,
      currency,
      date,
      due_date,
      note,
      account_id,
      tx_id,
      status,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun insert(
    id: String,
    direction: String,
    counterparty: String,
    principal: Long,
    interest: Long,
    currency: String,
    date: String,
    due_date: String?,
    note: String?,
    account_id: String?,
    tx_id: String?,
    status: String,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
  ) {
    driver.execute(1_603_334_019, """
        |INSERT INTO loan(id, direction, counterparty, principal, interest, currency, date, due_date, note, account_id, tx_id, status, order_index, created_at, updated_at)
        |VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?)
        """.trimMargin(), 15) {
          bindString(0, id)
          bindString(1, direction)
          bindString(2, counterparty)
          bindLong(3, principal)
          bindLong(4, interest)
          bindString(5, currency)
          bindString(6, date)
          bindString(7, due_date)
          bindString(8, note)
          bindString(9, account_id)
          bindString(10, tx_id)
          bindString(11, status)
          bindLong(12, order_index)
          bindLong(13, created_at)
          bindLong(14, updated_at)
        }
    notifyQueries(1_603_334_019) { emit ->
      emit("loan")
    }
  }

  public fun update(
    counterparty: String,
    interest: Long,
    due_date: String?,
    note: String?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(1_948_280_211,
        """UPDATE loan SET counterparty = ?, interest = ?, due_date = ?, note = ?, updated_at = ? WHERE id = ?""",
        6) {
          bindString(0, counterparty)
          bindLong(1, interest)
          bindString(2, due_date)
          bindString(3, note)
          bindLong(4, updated_at)
          bindString(5, id)
        }
    notifyQueries(1_948_280_211) { emit ->
      emit("loan")
    }
  }

  public fun setStatus(
    status: String,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(1_565_937_130, """UPDATE loan SET status = ?, updated_at = ? WHERE id = ?""", 3)
        {
          bindString(0, status)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(1_565_937_130) { emit ->
      emit("loan")
    }
  }

  public fun updateFromRemote(
    direction: String,
    counterparty: String,
    principal: Long,
    interest: Long,
    currency: String,
    date: String,
    due_date: String?,
    note: String?,
    account_id: String?,
    tx_id: String?,
    status: String,
    order_index: Long,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(2_061_548_163,
        """UPDATE loan SET direction = ?, counterparty = ?, principal = ?, interest = ?, currency = ?, date = ?, due_date = ?, note = ?, account_id = ?, tx_id = ?, status = ?, order_index = ?, updated_at = ? WHERE id = ?""",
        14) {
          bindString(0, direction)
          bindString(1, counterparty)
          bindLong(2, principal)
          bindLong(3, interest)
          bindString(4, currency)
          bindString(5, date)
          bindString(6, due_date)
          bindString(7, note)
          bindString(8, account_id)
          bindString(9, tx_id)
          bindString(10, status)
          bindLong(11, order_index)
          bindLong(12, updated_at)
          bindString(13, id)
        }
    notifyQueries(2_061_548_163) { emit ->
      emit("loan")
    }
  }

  public fun softDelete(
    deleted_at: Long?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(-372_713_921,
        """UPDATE loan SET is_deleted = 1, deleted_at = ?, updated_at = ? WHERE id = ?""", 3) {
          bindLong(0, deleted_at)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(-372_713_921) { emit ->
      emit("loan")
    }
  }

  public fun restore(updated_at: Long, id: String) {
    driver.execute(1_599_094_532,
        """UPDATE loan SET is_deleted = 0, deleted_at = NULL, updated_at = ? WHERE id = ?""", 2) {
          bindLong(0, updated_at)
          bindString(1, id)
        }
    notifyQueries(1_599_094_532) { emit ->
      emit("loan")
    }
  }

  public fun markSynced(
    synced_at: Long?,
    id: String,
    updated_at: Long,
  ) {
    driver.execute(830_179_697,
        """UPDATE loan SET synced_at = ? WHERE id = ? AND updated_at <= ?""", 3) {
          bindLong(0, synced_at)
          bindString(1, id)
          bindLong(2, updated_at)
        }
    notifyQueries(830_179_697) { emit ->
      emit("loan")
    }
  }

  private inner class SelectByIdQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("loan", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("loan", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-1_433_608_520,
        """SELECT loan.id, loan.direction, loan.counterparty, loan.principal, loan.interest, loan.currency, loan.date, loan.due_date, loan.note, loan.account_id, loan.tx_id, loan.status, loan.order_index, loan.created_at, loan.updated_at, loan.is_deleted, loan.deleted_at, loan.synced_at FROM loan WHERE id = ? AND is_deleted = 0""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "Loan.sq:selectById"
  }

  private inner class SelectByIdAnyStateQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("loan", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("loan", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(911_915_229,
        """SELECT loan.id, loan.direction, loan.counterparty, loan.principal, loan.interest, loan.currency, loan.date, loan.due_date, loan.note, loan.account_id, loan.tx_id, loan.status, loan.order_index, loan.created_at, loan.updated_at, loan.is_deleted, loan.deleted_at, loan.synced_at FROM loan WHERE id = ?""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "Loan.sq:selectByIdAnyState"
  }
}
